import React, { useCallback } from "react";
import { connect } from "react-redux";
import FormField from '../../../../../dynamicFormBuilder/FormField';
import { UserDefinedLayout } from '../Layout';

function UserDefinedTab(props) {
    var currentUser = props.oidc?.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;

    const handleFieldValueChange = useCallback((name, value) => {
        props.handleFieldChange(name, value);
    }, [props.handleFieldChange]);

    const onFormLoad = useCallback(() => {}, []);

    return (
        <div>
            <FormField
                currrentUser={currentUser}
                layoutId='A3B4C5D6-E7F8-9012-3456-789ABCDEF012'
                layoutName='WMSchedulesManagementUserDefinedForm'
                defaultFormSchema={UserDefinedLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={handleFieldValueChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={props.formRefs}
                onFormLoad={onFormLoad}
            />
        </div>
    );
}

function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}

export default connect(mapStateToProps)(UserDefinedTab);
